<div class="pessoa-tipo-card-control-radio">
    <ng-template [ngIf]="disabled">
        <input type="text" class="form-control" [value]="ngModel | pessoaTipo | uppercase" disabled="disabled" readonly="readonly">
    </ng-template>
    
    <div class="card-control-radio-container" *ngIf="!disabled">
        <ng-template ngFor let-tipo [ngForOf]="tipos">
            <div class="card card-control-radio" [class.active]="ngModel === tipo.id" (click)="onChange(tipo.id)">
                <div class="custom-control custom-radio">
                    <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_{{tipo.id}}" [value]="tipo.id" [ngModel]="ngModel" (ngModelChange)="onChange($event)"
                        #tipoPessoaModel="ngModel" #controlInput [required]="required" [autofocus]="autofocus">                     
                    <label class="custom-control-label" for="tipoPessoa_{{tipo.id}}">
                        <span class="custom-control-label-title">
                            <i class="{{tipo.id | pessoaTipoIcon}}"></i> {{tipo.nome}}
                        </span>
                        <span class="custom-control-label-subtitle">
                            {{tipo.descricao}}
                        </span>
                    </label>
                </div> 
            </div>
    
            <sgt-form-control-error
                *ngIf="tipoPessoaModel.errors && tipoPessoaModel.errors.required && tipoPessoaModel.dirty"
                [msgError]="msgErrorRequired">
            </sgt-form-control-error>
        </ng-template> 
    </div>
</div>